import React from "react";
import "./Gpmsaudience.css";

/* ============================================================
   CONTENT  (client ka content – yahin se edit karo)
   ============================================================ */
const HEAD = {
  badge: "WHO IT'S FOR",
  title: "Built for Modern Ports & Logistics Operations",
  subtitle: "Designed for Complex, Data-Intensive Environments",
  intro:
    "GPMS is suitable for organizations seeking improved operational visibility and predictive intelligence across port and container-handling activities.",
};

const AUDIENCE = [
  {
    title: "Port Authorities",
    desc: "Gain consolidated operational insights to support performance monitoring and planning.",
    icon: "landmark",
  },
  {
    title: "Container Terminal Operators",
    desc: "Monitor container flows, gate activity, dwell time, and terminal productivity.",
    icon: "container",
  },
  {
    title: "Multi-Terminal Operators",
    desc: "Analyze performance across multiple terminal locations and operational systems.",
    icon: "network",
  },
  {
    title: "Inland Container Depots (ICDs)",
    desc: "Improve visibility into container movements, truck turnaround, and dwell performance.",
    icon: "truck",
  },
  {
    title: "Logistics & Container Handling Facilities",
    desc: "Strengthen operational monitoring and identify potential movement and capacity bottlenecks.",
    icon: "warehouse",
  },
];

/* ============================================================
   ICONS
   ============================================================ */
const ICONS = {
  landmark: (
    <>
      <path d="M3 22h18" />
      <path d="M6 18v-7M10 18v-7M14 18v-7M18 18v-7" />
      <path d="M12 2 20 7H4z" />
    </>
  ),
  container: (
    <>
      <path d="M22 7.7c0-.6-.4-1.2-.8-1.5l-6.3-3.9a1.72 1.72 0 0 0-1.7 0l-10.3 6c-.5.2-.9.8-.9 1.4v6.6c0 .5.4 1.2.8 1.5l6.3 3.9a1.72 1.72 0 0 0 1.7 0l10.3-6c.5-.3.9-1 .9-1.5Z" />
      <path d="M10 21.9V14L2.1 9.1" />
      <path d="m10 14 11.9-6.9" />
      <path d="M14 19.8v-8.1" />
      <path d="M18 17.5V9.4" />
    </>
  ),
  network: (
    <>
      <circle cx="18" cy="5" r="3" />
      <circle cx="6" cy="12" r="3" />
      <circle cx="18" cy="19" r="3" />
      <path d="m8.59 13.51 6.83 3.98M15.41 6.51l-6.82 3.98" />
    </>
  ),
  truck: (
    <>
      <path d="M14 18V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v11a1 1 0 0 0 1 1h2" />
      <path d="M15 18H9" />
      <path d="M19 18h2a1 1 0 0 0 1-1v-3.65a1 1 0 0 0-.22-.624l-3.48-4.35A1 1 0 0 0 17.52 8H14" />
      <circle cx="17" cy="18" r="2" />
      <circle cx="7" cy="18" r="2" />
    </>
  ),
  warehouse: (
    <>
      <path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z" />
      <path d="M6 18h12M6 14h12" />
    </>
  ),
};

const Icon = ({ name }) => (
  <svg
    viewBox="0 0 24 24"
    width="30"
    height="30"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {ICONS[name]}
  </svg>
);

/* ============================================================
   SECTION
   ============================================================ */
const GPMSAudience = () => (
  <section className="ga">
    <div className="ga__container">
      <header className="ga__head">
        <span className="ga__pill">{HEAD.badge}</span>
        <h2 className="ga__title">{HEAD.title}</h2>
        <p className="ga__subtitle">{HEAD.subtitle}</p>
        <span className="ga__underline" />
        <p className="ga__intro">{HEAD.intro}</p>
      </header>

      <div className="ga__grid">
        {AUDIENCE.map((a, i) => (
          <article className="ga__card" key={a.title}>
            <span className="ga__num" aria-hidden="true">
              {String(i + 1).padStart(2, "0")}
            </span>
            <span className="ga__icon">
              <Icon name={a.icon} />
            </span>
            <h3 className="ga__card-title">{a.title}</h3>
            <p className="ga__card-desc">{a.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default GPMSAudience;